import { cn } from '../../utils';

export interface LoadingStateProps {
  rows?: number;
  columns?: number;
  className?: string;
  label?: string;
  title?: string;
}

/**
 * Skeleton rows for DataTable loading state. Also usable standalone.
 * Uses `animate-pulse`; no external spinner library.
 */
export function LoadingState({
  rows = 5,
  columns = 4,
  className,
  label,
  title,
}: LoadingStateProps) {
  const accessibleLabel = label ?? title ?? 'Loading';
  return (
    <output
      className={cn('flex flex-col gap-2 px-4 py-4', className)}
      aria-live="polite"
      aria-label={accessibleLabel}
    >
      {title ? (
        <span className="text-[13px] text-[var(--color-text-secondary)]">{title}</span>
      ) : null}
      {Array.from({ length: rows }, (_, r) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — never reordered
          key={`r${r}`}
          className="flex gap-3"
        >
          {Array.from({ length: columns }, (_, c) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — never reordered
              key={`c${c}`}
              className={cn(
                'h-5 rounded-[4px] animate-pulse',
                'bg-[var(--color-surface)]',
                c === 0 ? 'w-[14%]' : c === columns - 1 ? 'w-[18%]' : 'flex-1',
              )}
            />
          ))}
        </div>
      ))}
    </output>
  );
}
